import axios from "axios";
import { log as logger } from "../utils/Logging"; //Limitless imports

import ClientContext from "../utils/client-context/ClientContext";
export var getWebSocketURL = function getWebSocketURL(successCallback, errorCallback) {
  var log = logger.getLogger("WebSocketActions getWebSocketURL");
  var configURL = "".concat(process.env.REACT_APP_BASE_PLATFORM_URL).concat(process.env.REACT_APP_STAGE, "/public/config?name=realtimeendpoint");
  axios.get(configURL, {
    headers: {
      "x-api-key": ClientContext._apiKey
    }
  }).then(function (response) {
    log.debug("Successfully retreived web socket URL", response.data.url);

    if (typeof successCallback === "function") {
      successCallback(response.data.url);
    }
  }).catch(function (error) {
    if (typeof errorCallback === "function") {
      errorCallback(error);
    }
  });
};